import { render, staticRenderFns } from "./detailsALL.vue?vue&type=template&id=48880e59&scoped=true&"
import script from "./detailsALL.vue?vue&type=script&lang=js&"
export * from "./detailsALL.vue?vue&type=script&lang=js&"
import style0 from "./detailsALL.vue?vue&type=style&index=0&id=48880e59&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48880e59",
  null
  
)

export default component.exports